import React, { useContext, useEffect, useState } from 'react'
import { RootContext } from '../../context/rootContext'
import { Backdrop, BodyScrollLock, CloseButton, Modal, ModalContainer, ModalContent, ModalContentInner, ModalHeader } from 'components/styled'
import IncompletePetDataForm from '../incompletePetDataForm'

export const ACTION_MODAL_TYPE = {
  INCOMPLETE_PET_FORM: 'INCOMPLETE_PET_FORM'
}

const MODAL_CONTENT_MAP = {
  [ACTION_MODAL_TYPE.INCOMPLETE_PET_FORM]: IncompletePetDataForm
}

/**
 * Modal que demanda ação de usuário.
 *
 * Pode ser empilhável (ficará visível enquanto houver um elemento em sua pilha de
 * modais, no contexto raiz), e expõe um callback onSuccess, que será invocado
 * quando a ação de usuário for finalizada com sucesso.
 *
 * Seu estado deverá ser controlado inteiramente pelo contexto, onde através do
 * mesmo ele poderá ser aberto/fechado e será através dele que receberá os
 * parâmetros de renderização de seu conteúdo.
 */
const ActionModal = () => {
  const { actionModalStack, closeActionModal } = useContext(RootContext)
  const [visible, setVisible] = useState(false)
  const [content, setContent] = useState()
  const [windowHeight, setWindowHeight] = useState('0' || 0)

  useEffect(() => {
    const calculatedHeight = (typeof window !== 'undefined') ? window.innerHeight : 0
    setWindowHeight(calculatedHeight)
  }, [])

  useEffect(() => {
    if (actionModalStack.length > 0) {
      setVisible(true)

      const activeModal = actionModalStack[actionModalStack.length - 1]
      const Component = MODAL_CONTENT_MAP[activeModal.modalType]
      const handleSuccess = activeModal.onSuccess
      setContent(<Component {...activeModal.params} onSuccess={handleSuccess} />)
    } else {
      setVisible(false)
      setContent(null)
    }
  }, [actionModalStack])

  const onCloseModal = () => {
    closeActionModal()
  }

  return (
    <>
      <ModalContainer visible={visible} height={`${windowHeight}px`}>
        <Modal maxHeight='unset'>
          <ModalHeader>
            <CloseButton onClick={onCloseModal}>x</CloseButton>
          </ModalHeader>
          <ModalContent>
            <ModalContentInner height='360px'>
              {content}
            </ModalContentInner>
          </ModalContent>
        </Modal>
      </ModalContainer>
      <Backdrop visible={visible} onClick={onCloseModal} />
      <BodyScrollLock active={visible} />
    </>
  )
}

export default ActionModal
